import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image3 from "../../../images/financial/financial4.webp";
const CardSolutions = () => {
  const banner = {
    title: "Card Solutions",
    image: image3,
  };

  return (
    <>
      <Helmet>
        <title>
          Cards — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Cards </h2>
              <p>
                Financial institutions/banks thrive on meeting the needs of
                their commercial/retail customers while providing them with
                exceptional client experiences. With the global cards and
                payments industry, witnessing a diminishing trend in traditional
                banking and constantly progressing towards emerging digital
                technologies. Financial institutions are adopting new
                technologies and complying with constantly changing governance
                and regulations.
              </p>
              <p>
                Cylon Technologies provides a number of card solutions to manage
                card service tasks with our strategies that would maximize
                revenue, increase customer acquisition, improve retention,
                reduce expense, and in minimizing risk. Our technology approach
                with Software as a Service (SaaS) model, ensures resource
                optimization, reduces upfront hardware and software investment
                and guarantees high quality services.
              </p>
              <p>
                Our services and solutions comply with PCI-DSS requirements and
                ISO 20022 standards as we offer a complete suite of solutions
                for issuing and acquiring cards both as a service and as a
                licensed product. Our innovative approach combined with advanced
                fraud detection software with the personalized supervision of
                your risk management efforts helps in maintaining your
                customers/clients satisfaction.
              </p>
              <h2 className="heading2">
                Cylon Technologies card solutions include the following –{" "}
              </h2>

              <ul>
                <li>ATM solutions</li>
                <li>Credit & Debit Solutions</li>
                <li>Digital Card Enablement Solutions </li>
                <li>Fraud Risk Solutions</li>
                <li>Payment Network Solutions</li>
              </ul>

              <p>
                Our Card Management System (CMS) is helping our clients in
                offering innovative services and in maintaining the highest
                customer service levels. The CMS is a complete EMV certified
                system that manages both issuing and acquiring functions and is
                a leading end-to-end transaction management solution for banks
                and financial institutions to capitalize on the electronic
                payment revolution.
              </p>
              <p>
                The presence of Nano CMS combines several modules that can be
                used separately or in an integrated way to satisfy the specific
                needs of the financial organizations. Our CMS solutions are
                designed to manage customer’s accounts, products and
                transactions within a wide range of framework. Cylon
                Technologies card solutions payments domain include-
              </p>
              <p>
                Cash Pool – Under this service, we are offering value added
                services from banks to corporations across the globe for
                effective cash management with a capability of handling numerous
                types of bank accounts.
              </p>
              <p>
                Payment Platform – We have expertise in managing domestic,
                international and SEPA payment initiations and processing as per
                ISO 20022 standards.
              </p>
              <p>
                Message Transformation Engine - We have solutions to convert
                payment messages from any format to another such as ISO and
                SWIFT.
              </p>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">
                    Our Card Solutions support the following products –
                  </h2>
                  <ul>
                    <li>Debit Cards</li>
                    <li>Credit Cards</li>
                    <li>Open Loop Prepaid Cards</li>
                    <li>WPS Cards</li>
                    <li>Digital Wallet</li>
                    <li>Integrated Loyalty and Payment Cards</li>
                    <li>Closed Loop Prepaid Cards</li>
                    <li>Closed Loop Gift Cards</li>
                    <li>Co-Branded Cards</li>
                    <li>Virtual Cards</li>
                    <li>Government Payments</li>
                  </ul>
                  <p>
                    We provide a single platform for complete end-to-end card
                    payment, management and processing as well as in
                    facilitating issuing and acquiring cards. Cylon Technologies
                    chip solutions are based on the following technologies-
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CardSolutions;
